import React from "react"

import {FieldEditableProps} from "../../../../proto/render/editable"
import {FieldViewSize} from "../../../../const"
import FieldTags from "../../tags"
import FieldTags_EditableValue from "./value"
import FieldTags_EditableValueHovered from "./value-hovered"

// const debug = "FieldTags_Editable"
const debug = false

type State = {
    isHovered   : boolean
    showPopover : boolean
}

type Props = FieldEditableProps & {
    renderValue         : func
    renderValueHovered  : func
}

export default class FieldTags_Editable extends React.Component<Props, State> {

    constructor(props:Props) {
        super(props)

        this.state = {
            isHovered   : false,
            showPopover : false
        }
    }

    onMouseEnter = () => {
        if (!this.props.field.canEdit(this.props.model)) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.showPopover) return

        if (this.state.isHovered) this.setState({
            isHovered: false
        })
    }

    onClick = () => {
        if (!this.props.field.canEdit(this.props.model)) return

        this.setState({
            showPopover: !this.state.showPopover
        })
    }

    // is called outside to open popover
    // currently it is used in Task View to open popover on first add tag in details
    openPopover = () => {
        debug && console.log(debug, 'openPopover')

        this.setState({
            isHovered   : true,
            showPopover : true
        })
    }

    get classes():string {
        const field     = this.props.field as FieldTags

        return Classes("ui5-field-editable", this.props.className, {
            "multiselect"   : !field.isEmpty(this.props.model),
            "size-default"  : this.props.size === FieldViewSize.DEFAULT,
            "size-small"    : this.props.size === FieldViewSize.SMALL,
            "is-hovered"    : this.state.isHovered
        })
    }

    onValueChange = (value:any, hidePopover:boolean = true) => {
        debug && console.log(debug, 'onValueChange', value, hidePopover)

        hidePopover && this.hidePopover()
        this.props.onChange && this.props.onChange(value, hidePopover)
    }

    onOptionClick = (option:Option, hidePopover:boolean = false) => {
        debug && console.log(debug, 'onOptionClick', option, hidePopover)
        const field     = this.props.field as any as FieldTags
        const newValue  = field.toggleValue(this.props.model, option.value)
        this.onValueChange(newValue, hidePopover)
    }

    hidePopover = () => {
        debug && console.log(debug, 'hidePopover')

        this.setState({
            showPopover : false,
            isHovered   : false
        })
    }

    onResetValueClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        this.onValueChange(null, false)
    }

    renderHovered() {
        const field : FieldTags     = this.props.field as any as FieldTags
        const value = field.getViewValue(this.props.model)


        // style={{marginRight: '-6px', marginTop: '6px'}}

        return (
            <>
                <div className={this.classes} style={this.props.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={this.onClick}>
                    <div className="flex-row-between-top w-100-percent h-100-percent">
                        <FieldTags_EditableValueHovered field           = {field}
                                                        model           = {this.props.model}
                                                        onValueChange   = {this.onValueChange}/>

                        <div className="buttons-absolute flex-no-shrink">
                            {!_.isEmpty(value) &&
                                <div className="btn-reset" onClick={this.onResetValueClick}/>
                            }
                            <div className="btn-arrow"/>
                            {/*<ControlButtonStandard className="btn-add" type={ControlButtonType.PLUS} hint="Add tag" size={24}/>*/}
                        </div>
                    </div>
                </div>
                {this.state.showPopover &&
                    <field.components.PopoverMenu {...this.props} parent={this} />}
            </>
        )
    }

    renderNotHovered() {
        return (
            <div className={this.classes} style={this.props.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                <FieldTags_EditableValue field  = {this.props.field as FieldTags}
                                         model  = {this.props.model}/>
            </div>
        )
    }

    render() {
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        if (this.state.isHovered)   return this.renderHovered()
        else                        return this.renderNotHovered()
    }
}

